import { render, staticRenderFns } from "./memberAdd.vue?vue&type=template&id=74894956"
import script from "./memberAdd.vue?vue&type=script&lang=js"
export * from "./memberAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports